<div class="additional-specification">
  <!-- additional specification title -->
  <div
    class="additional-specification__box"
    [ngClass]="{ 'h-90 !max-h-90 items-center': heightMax() }">
    <p class="additional-title">{{ additionalTitle() || '' | translate }}</p>
    @if (!!additionalTitleSuffix()) {
      <p class="additional-subtitle">
        {{ additionalTitleSuffix() || '' | translate }}
      </p>
    }
  </div>
  <!-- additional specification value -->
  <div
    class="additional-specification__box"
    [ngClass]="{ '!min-h-90 !h-max !max-h-none items-center': heightMax() }">
    <ng-content></ng-content>
  </div>
</div>
